import ExcelJS from 'exceljs';
import { BORDER, setColWidths, workbookToDownload } from '../../documentos/commercialExcelUtils';
import { gradeHeightFileBase } from './buildGradeHeightParams';
import { appendGradeHeightSignatureExcel } from './gradeHeightSignature';

const FONT = { name: 'Arial', size: 8 };
const COL_WIDTHS = [13.33, 8.78, 14.78, 8.78, 18.5, 13.89, 8.78, 12];

const HEADERS = [
  'Container',
  'Grade',
  'Pieces per bundle',
  'Bundles',
  'Thickness/Height',
  'Width',
  'Length',
  'Total',
];

const NO_BORDER = {};

/** Miles (length/width); m³ hasta 3 decimales sin ceros de relleno (es-CL). */
const NUM_FMT_WIDTH_LENGTH = '#,##0';
const NUM_FMT_M3 = '#.##0,###';

function setCell(ws, r, c, value, opts = {}) {
  const cell = ws.getCell(r, c);
  const empty = value == null || value === '';
  cell.value = empty ? null : value;
  if (opts.numFmt && !empty && typeof value === 'number') {
    cell.numFmt = opts.numFmt;
  }
  cell.font = { ...FONT, ...(opts.bold ? { bold: true } : {}) };
  cell.alignment = {
    vertical: 'middle',
    horizontal: opts.align?.horizontal ?? 'center',
    wrapText: false,
  };
  if (opts.border === false) cell.border = NO_BORDER;
  else if (opts.border) cell.border = BORDER;
}

function writeDetailRow(ws, r, d) {
  setCell(ws, r, 1, d.container || null, { border: true });
  setCell(ws, r, 2, d.grade, { border: true });
  setCell(ws, r, 3, d.piecesPerBundle, { border: true });
  setCell(ws, r, 4, d.bundles, { border: true });
  setCell(ws, r, 5, d.thicknessHeight, { border: true });
  if (d.widthValue != null) {
    setCell(ws, r, 6, d.widthValue, { border: true, numFmt: NUM_FMT_WIDTH_LENGTH });
  } else {
    setCell(ws, r, 6, d.width || null, { border: true });
  }
  setCell(ws, r, 7, d.lengthValue, { border: true, numFmt: NUM_FMT_WIDTH_LENGTH });
  setCell(ws, r, 8, d.totalValue, { border: true, numFmt: NUM_FMT_M3 });
  ws.getRow(r).height = 8.5;
}

function writeGroupTotalRow(ws, r, totalM3Value) {
  for (let c = 1; c <= 8; c += 1) {
    setCell(ws, r, c, null, { border: true });
  }
  setCell(ws, r, 6, 'Total', { bold: true, border: true });
  setCell(ws, r, 8, totalM3Value, { bold: true, border: true, numFmt: NUM_FMT_M3 });
  ws.getRow(r).height = 8.5;
}

export function gradeHeightExcelFileName(params) {
  return `${gradeHeightFileBase(params)}.xlsx`;
}

export async function buildGradeHeightExcelWorkbook(params) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Grade Height');
  setColWidths(ws, COL_WIDTHS);

  const titleFont = { name: 'Arial', size: 11, bold: true };
  ws.getCell(1, 1).value = 'Invoice';
  ws.getCell(1, 1).font = titleFont;
  ws.getCell(1, 2).value = params.numeroInvoice || null;
  ws.getCell(1, 2).font = titleFont;
  ws.getCell(2, 1).value = 'Height';
  ws.getCell(2, 1).font = titleFont;
  ws.getRow(1).height = 12;
  ws.getRow(2).height = 12;

  HEADERS.forEach((h, i) => {
    setCell(ws, 3, i + 1, h, { bold: true, border: true });
  });
  ws.getRow(3).height = 9.5;

  let r = 4;
  const groups = params.groups || [];
  groups.forEach((group, gi) => {
    group.detailRows.forEach((d) => {
      writeDetailRow(ws, r, d);
      r += 1;
    });
    writeGroupTotalRow(ws, r, group.totalM3Value);
    r += 1;
    if (gi < groups.length - 1) {
      ws.getRow(r).height = 10;
      r += 1;
      ws.getRow(r).height = 10;
      r += 1;
    }
  });

  const afterSig = await appendGradeHeightSignatureExcel(ws, wb, r);

  ws.pageSetup = {
    orientation: 'portrait',
    paperSize: 9,
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 0,
    margins: { left: 0.4, right: 0.4, top: 0.4, bottom: 0.4, header: 0, footer: 0 },
  };
  ws.pageSetup.printArea = `A1:H${afterSig}`;

  return wb;
}

export async function generateGradeHeightExcel(params) {
  const wb = await buildGradeHeightExcelWorkbook(params);
  await workbookToDownload(wb, gradeHeightExcelFileName(params));
}
